import { render } from "./PrimaryNavigation.vue?vue&type=template&id=7b6d8b42&scoped=true"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=js"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=js"

import "./PrimaryNavigation.vue?vue&type=style&index=0&id=7b6d8b42&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6d8b42"]])

export default __exports__